module.exports = __webpack_public_path__ + "media/flags/as-0f86acd1.svg";